module.exports = __webpack_public_path__ + "static/media/gateway-alpha-page.671946ef.png";